// extracted by mini-css-extract-plugin
export var blink = "search_form-module--blink--FM8Ty";
export var search_box = "search_form-module--search_box--y942h";
export var search_box__input = "search_form-module--search_box__input--evjaJ";
export var search_box_mobile_display = "search_form-module--search_box_mobile_display--VcppK";